import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './app';
import store from "./app/store"
import { Provider } from 'react-redux';


// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <HelmetProvider>

      <HashRouter>
        <Suspense>
      <Provider store={store}>
    <App />
    </Provider>
        </Suspense>
      </HashRouter>
   
  </HelmetProvider>
);
